
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Booking from "@/domain/booking/Booking";
import DialogBanner from "@/components/app/DialogBanner.vue";
import RemoteServices from "@/services/RemoteServices";
import BookingOverviewComponent from "@/components/booking/components/BookingOverviewComponent.vue";
@Component({
  components: { BookingOverviewComponent, DialogBanner }
})
export default class BookingStatusDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: null })
  booking!: Booking;

  statusString = this.booking.status;

  loading = false;

  message = "";

  @Watch("booking")
  reset() {
    this.statusString = this.booking.status;
    this.loading = false;
  }

  get dialog() {
    return this.value;
  }

  set dialog(newVal: boolean) {
    this.$emit("input", newVal);
    this.reset();
  }

  get colour() {
    return Booking.getBookingStatusDisplayColour(this.statusString);
  }

  get hasChanges() {
    return this.statusString !== this.booking.status;
  }

  get customerName() {
    if (this.booking != null && this.booking.customerName !== undefined) {
      return this.booking.getTruncatedCustomerName();
    }
    return "";
  }

  possibleStatus = Booking.bookingStatuses.filter(s => {
    return s.allowSelection;
  });

  async updateStatus() {
    if (this.hasChanges) {
      this.loading = true;
      try {
        const bookingCopy = await RemoteServices.updateBookingStatus(
          this.booking.bookingId,
          this.statusString,
          this.message
        );
        await this.$store.dispatch(
          "success",
          this.$t("booking.edit.status.success")
        );
        this.emitUpdateBooking(bookingCopy);
        this.dialog = false;
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    }
  }

  emitUpdateBooking(bookingCopy: Booking) {
    this.$emit("update-booking", bookingCopy);
  }
}
